<div class="weight-selector" [class.disabled]="disabled">
    <div tabindex="0" class="weight-card"
         *ngFor="let option of weightOptions"
         [class.selected]="selectedWeight === option.value"
         (click)="selectWeight(option.value)" (keydown.enter)="selectWeight(option.value)">
        <div class="weight-card-content">
            <div class="weight-card-header">
                <strong>{{ option.label }}</strong>
            </div>
        </div>
        <div class="weight-card-radio">
            <i [class]="selectedWeight === option.value ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
        </div>
    </div>

    <div class="caution-banner" *ngIf="isHighSelected">
        <i class="pi pi-exclamation-triangle caution-icon"></i>
        <div class="caution-text">
            <strong>Caution: High weight selected</strong>
            <p>This may significantly impact risk scoring. Use this diversion weight only when supported by local diversion risk evidence.</p>
        </div>
    </div>

    <div tabindex="0" class="learn-more" (click)="toggleLearnMore()" (keydown.enter)="toggleLearnMore()">
        <span>Learn more about Diversion Weight and Risk Score</span>
        <i [class]="showLearnMore ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
    </div>

    <div class="learn-more-content" *ngIf="showLearnMore">
        <h4>What is Diversion Weight?</h4>
        <p>Controls how strongly a medication group influences user risk scoring within the Diversion Management Application. Diversion Weight defines a medication group's relative impact on a user's overall risk score.</p>
        <h4>Scoring Impact</h4>
        <p>Diversion Weight adjusts the signal influence of a medication group within the existing risk scoring framework, which includes Peer Analytics Score and Variance Score. Updates apply prospectively to future risk scores.</p>
        <p class="best-practice"><strong>Best Practice:</strong> Start with a conservative weight and adjust over time based on investigation outcomes and organizational risk tolerance.</p>
    </div>
</div>
